import React, { Component } from "react";
import "firebase/functions";
import Moment from "moment";
import "moment/locale/es";
import Connector from "../../data/Connector";
import Navigation from "../../components/Navigation";
import { Link, withRouter } from "react-router-dom";
import EventEmitter from "../../helper/Emitter";
import DataInfo from "../../components/Form/info";
import {
  AuthUserContext,
  withAuthorizationMember,
} from "../../components/Session";

import { withTranslation } from "react-i18next";
import lang from "i18next";

class MembershipPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client: global.spaceClient,
      packs: [],
      memberships: [],
      unpaid: [],
      start: Moment().add(-1, "month"),
      end: Moment(),
      header: "This month",
      ugroup: false,
      u11: false,
      available: [0, 0],
    };
  }

  componentDidMount() {
    var arr = this.props.location.pathname.split("/");
    var id = arr[arr.length - 2];
    if (id !== "home" && id !== "member") {
      global.uid = id;
    }
    Connector.setUser();
    document.title = "Your Membership - " + global.userBusiness;

    EventEmitter.subscribe("userLoaded", (event) => this.configureData());
    EventEmitter.subscribe("sessionsLoaded", (event) => this.configureData());
    EventEmitter.subscribe("subsLoaded", (event) => this.configureData());
    this.configureData();
  }

  componentWillUnmount() {
    EventEmitter.unsubscribe("userLoaded", () => {});
    EventEmitter.unsubscribe("sessionsLoaded", () => {});
    EventEmitter.unsubscribe("subsLoaded", () => {});
  }

  configureData() {
    var packs = [];
    var memberships = [];
    var unpaid = [];
    var start = Moment().add(-1, "month");
    var end = Moment();
    var header = "This month";

    // Add a member selector

    var ugroup = false;
    var u11 = false;
    var available = [0, 0];

    var num1 = this.getAvailable(true, this.state.client);
    if (global.userLinked.length > 0) {
      num1 += this.getAvailable(true, "");
    }

    var num2 = this.getAvailable(false, this.state.client);
    if (global.userLinked.length > 0) {
      num2 += this.getAvailable(false, "");
    }

    var endDate = Moment().add(7, "days");
    for (var item1 of global.subscriptions) {
      if (
        item1.data.account === item1.data.client ||
        item1.data.account === ""
      ) {
        endDate = Moment(item1.data.next, "X");
      }
    }

    for (var item2 of global.sessions) {
      var hasclient = false;
      if (item2.data.clients !== undefined) {
        if (item2.data.clients.indexOf(this.state.client) !== -1) {
          hasclient = true;
        }
      }
      if (
        Moment(item2.data.timestamp, "X") > Moment() &&
        Moment(item2.data.timestamp, "X") < endDate &&
        item2.data.group &&
        hasclient &&
        (!item2.data.availability || item2.data.availability === undefined)
      ) {
        num1 += 1;
      }
      if (
        Moment(item2.data.timestamp, "X") > Moment() &&
        Moment(item2.data.timestamp, "X") < endDate &&
        (item2.data.group || item2.data.availability) &&
        item2.data.client === this.state.client
      ) {
        num2 += 1;
      }
    }

    if (num1 < 0) {
      available[0] = -num1;
    } else if (num1 > 0) {
      unpaid.push({
        id: "group",
        name: "Classes",
        group: true,
        paid: 0,
        done: num1,
        expires: false,
        expiry: Moment(),
        account: "",
        product: "",
      });
    }

    if (num2 < 0) {
      available[1] = -num2;
    } else if (num2 > 0) {
      unpaid.push({
        id: "11",
        name: "1:1 sessions",
        group: false,
        paid: 0,
        done: num2,
        expires: false,
        expiry: Moment(),
        account: "",
        product: "",
      });
    }

    for (var item3 of global.credits) {
      var expires = 0;
      if (item3.data.expires !== undefined) {
        expires = item3.data.expires;
      }
      if (
        Moment(expires, "X") > Moment() &&
        (item3.data.account === this.state.client ||
          item3.data.account === "" ||
          item3.data.account === undefined) &&
        item3.data.sessionsPaid > item3.data.sessionsTotal
      ) {
        packs.push(item3);
      }
    }
    for (var item4 of global.credits) {
      if (
        item4.data.expires === undefined &&
        item4.data.sessionsPaid > item4.data.sessionsTotal &&
        (item4.data.account === this.state.client ||
          item4.data.account === "" ||
          item4.data.account === undefined)
      ) {
        packs.push(item4);
      }
    }

    var d1 = Moment().format("MM/YYYY");
    start = Moment("01/" + d1, "DD/MM/YYYY");
    var s1 = start.format("X");
    var d2 = Moment(s1, "X").add(1, "month");
    end = d2.add(-1, "day");

    for (var item5 of global.subscriptions) {
      var interval = 1;
      if (item5.data.interval !== undefined) {
        interval = item5.data.interval;
      }
      if (
        item5.data.account === this.state.client ||
        item5.data.account === "" ||
        item5.data.account === undefined
      ) {
        memberships.push(item5);
        start = Moment(item5.data.next, "X").add(-(interval * 7), "days");
        if (item5.data.billing === "fortnight") {
          start = Moment(item5.data.next, "X").add(-14, "days");
        }
        if (item5.data.billing === "month") {
          start = Moment(item5.data.next, "X").add(-interval, "months");
        }
        end = Moment(item5.data.next, "X");
        if (item5.data.sessions === 0 && item5.data.group) {
          ugroup = true;
        }
        if (item5.data.sessions === 0 && !item5.data.group) {
          u11 = true;
        }
        header =
          "Current period: " + start.format("LL") + " - " + end.format("LL");
      }
    }

    this.setState({
      packs: packs,
      memberships: memberships,
      unpaid: unpaid,
      start: start,
      end: end,
      header: header,
      ugroup: ugroup,
      u11: u11,
      available: available,
    });
  }

  getAvailable(group, id) {
    if (id === undefined) {
      id = "";
    }
    var more = 0;
    var num = 0;
    var nump = 0;
    var numt = 0;

    var family = false;
    if (global.userLinked.length > 0) {
      family = true;
    }

    more = this.getClientSessionDebit(group, "", !family);
    for (var item of global.credits) {
      var expires = 0;
      if (item.data.expires !== undefined) {
        expires = item.data.expires;
      }
      if (!family) {
        // Non family
        if (item.data.group === group) {
          if (expires === 0 || Moment(expires, "X") > Moment()) {
            nump += item.data.sessionsPaid;
            numt += item.data.sessionsTotal;
          }
        }
      } else {
        // Family main account
        if (item.data.group === group && item.data.account === id) {
          if (expires === 0 || Moment(expires, "X") > Moment()) {
            nump += item.data.sessionsPaid;
            numt += item.data.sessionsTotal;
          }
        }
      }
    }
    num = numt - nump;
    num -= more;

    return num;
  }

  getClientSessionDebit(group, id, limit) {
    var add = 0;
    var current = Moment();

    for (var item of global.subscriptions) {
      var interval = 1;
      if (item.data.interval !== undefined) {
        interval = item.data.interval;
      }
      current = Moment(item.data.next, "X").add(-7, "days");
      if (interval > 1) {
        current = Moment(item.data.next, "X").add(-7 * interval, "days");
      }
      if (item.data.billing === "month") {
        current = Moment(item.data.next, "X").add(-interval, "months");
      } else if (item.data.billing === "fortnight") {
        current = Moment(item.data.next, "X").add(-14, "days");
      }
      // Normal accounts
      if (!limit) {
        if (
          item.data.group === group &&
          Moment(item.data.next, "X") > Moment() &&
          current < Moment() &&
          item.data.status !== "trialing" &&
          item.data.status !== "unpaid" &&
          (item.data.pause === "" || item.data.pause === undefined) &&
          (item.data.account === "" ||
            item.data.account === id ||
            item.data.account === undefined)
        ) {
          add += item.data.sessions - item.data.done;
        }
        // For both
        if (
          !item.data.group &&
          !group &&
          item.data.is11 &&
          Moment(item.data.next, "X") > Moment() &&
          current < Moment() &&
          item.data.status !== "trialing" &&
          item.data.status !== "unpaid" &&
          (item.data.pause === "" || item.data.pause === undefined) &&
          (item.data.account === "" ||
            item.data.account === id ||
            item.data.account === undefined)
        ) {
          add += item.data.sessions11 - item.data.done11;
        }
      } else {
        // Family accounts
        if (
          item.data.group === group &&
          Moment(item.data.next, "X") > Moment() &&
          current < Moment() &&
          item.data.status !== "trialing" &&
          item.data.status !== "unpaid" &&
          (item.data.pause === "" || item.data.pause === undefined) &&
          item.data.account === id
        ) {
          add += item.sessions - item.done;
        }
        // For both
        if (
          !item.data.group &&
          !group &&
          item.data.is11 &&
          Moment(item.data.next, "X") > Moment() &&
          current < Moment() &&
          item.data.status !== "trialing" &&
          item.data.status !== "unpaid" &&
          (item.data.pause === "" || item.data.pause === undefined) &&
          (item.data.account === "" || item.data.account === undefined)
        ) {
          add += item.sessions11 - item.done11;
        }
      }
    }
    return add;
  }

  // Membership information

  getMembershipInfo(item) {
    var type = " sessions";
    if (item.data.sessions === 1) {
      type = " session";
    }
    if (item.data.group) {
      type = " classes";
      if (item.data.sessions === 1) {
        type = " class";
      }
    }
    var billed = item.data.billing + "ly";
    var interval = 1;
    if (item.data.inteval !== undefined) {
      interval = item.data.interval;
    }
    if (interval !== 1) {
      billed = "every " + String(interval) + " " + item.data.billing + "s";
    }
    var add = "";
    if (item.data.is11) {
      add =
        " & " +
        item.data.sessions11 +
        "session" +
        (item.data.sessions11 === 1 ? "" : "s");
      if (item.data.done11 > 0) {
        add =
          " & " +
          item.data.sessions11 +
          "session" +
          (item.data.sessions11 === 1 ? "" : "s") +
          " (" +
          item.data.done11 +
          " used)";
      }
    }
    let label =
      (item.data.sessions === 0
        ? lang.t("overview:member.unlimited")
        : item.data.sessions) +
      type +
      (item.done > 0 ? " (" + item.data.done + " used)" : "") +
      add +
      this.getFamilyInfo(item.data.account) +
      " - Billed " +
      billed;
    return label;
  }

  getFamilyInfo(account) {
    var label = "";
    if (
      account === "" &&
      (global.userLinked.length > 0 || global.userParent !== "")
    ) {
      label = " (All members)";
    }
    return label;
  }

  getMembershipBilling(item) {
    var label = "";
    if (item.data.pause === "" || item.data.pause === undefined) {
      if (item.data.status === "trialing") {
        label = "Starts " + Moment(item.data.next, "X").format("LL");
      } else {
        label = "Active";
      }
    } else {
      label = "Paused until " + Moment(item.data.pause, "X").format("LL");
    }
    return label;
  }

  // Credit info

  getPackInfo(item) {
    var label = "";
    var type = " classes";
    if (item.data.sessionsPaid === 1) {
      type = " class";
    }
    if (!item.data.group) {
      type = " sessions";
      if (item.data.sessionsPaid === 1) {
        type = " session";
      }
    }
    label =
      item.data.sessionsPaid +
      type +
      (item.data.sessionsTotal > 0
        ? " (" + item.data.sessionsTotal + " used)"
        : "") +
      this.getFamilyInfo(item.data.account) +
      "\nExpire " +
      Moment(item.data.expires, "X").format("LL");
    if (item.data.expires !== undefined) {
      if (Moment(item.data.expires, "X") > Moment().add(4, "days")) {
        //label += '\nActive'
      } else {
        label += "\n" + lang.t("overview:member.expiresoon");
      }
    } else {
      label =
        item.data.sessionsPaid -
        item.data.sessionsTotal +
        (item.data.group ? " classes" : " 1:1 sessions") +
        this.getFamilyInfo(item.data.account) +
        "\nN" +
        lang.t("overview:member.neverexpire");
    }
    return label;
  }

  getPackIcon(item) {
    var label = "session";
    if (item.data.group) {
      label = "group";
    }
    return label;
  }

  getSessions(type) {
    var num = 0;
    for (var item of global.sessions) {
      if (type === "attended") {
        if (
          Moment(item.data.timestamp, "X") < Moment() &&
          item.data.attendance === 3 &&
          Moment(item.data.timestamp, "X") > this.state.start &&
          Moment(item.data.timestamp, "X") < this.state.end
        ) {
          if (!item.data.group && item.data.client === this.state.client) {
            num++;
          }
          if (item.data.group && item.data.clients !== undefined) {
            if (item.data.clients.indexOf(this.state.client) !== -1) {
              num++;
            }
          }
        }
      }
      if (type === "noshows") {
        if (
          Moment(item.data.timestamp, "X") < Moment() &&
          Moment(item.data.timestamp, "X") > this.state.start &&
          Moment(item.data.timestamp, "X") < this.state.end
        ) {
          if (
            !item.data.group &&
            item.data.client === this.state.client &&
            item.data.attendance === 4
          ) {
            num++;
          }
          if (item.data.group && item.data.noshows !== undefined) {
            if (item.data.noshows.indexOf(this.state.client) !== -1) {
              num++;
            }
          }
        }
      }
      if (type === "bookedin") {
        if (
          Moment(item.data.timestamp, "X") > Moment() &&
          Moment(item.data.timestamp, "X") < Moment().add(1, "months")
        ) {
          if (!item.data.group && item.data.client === this.state.client) {
            num++;
          }
          if (item.data.group && item.data.clients !== undefined) {
            if (item.data.clients.indexOf(this.state.client) !== -1) {
              num++;
            }
          }
        }
      }
      if (type === "waitinglist") {
        if (
          Moment(item.data.timestamp, "X") > Moment() &&
          Moment(item.data.timestamp, "X") < Moment().add(1, "months")
        ) {
          if (item.data.group && item.data.waiting !== undefined) {
            if (item.data.waiting.indexOf(this.state.client) !== -1) {
              num++;
            }
          }
        }
      }
    }
    return num;
  }

  selectClient(item) {
    this.setState(
      {
        client: item.target.value,
      },
      () => {
        this.configureData();
      }
    );
  }

  // Display stuff ------------------------------------------------------------

  renderStats() {
    return (
      <div>
        <div className="info large col-3">
          <label>{lang.t("overview:member.attended")}</label>
          <p>{this.getSessions("attended")}</p>
        </div>
        <div className="info large col-3">
          <label>{lang.t("overview:member.noshows")}</label>
          <p>{this.getSessions("noshows")}</p>
        </div>
        <div className="info large col-3">
          <label>{lang.t("overview:member.bookedin")}</label>
          <p>{this.getSessions("bookedin")}</p>
        </div>
        <div className="info large col-3">
          <label>{lang.t("overview:member.waitinglist")}</label>
          <p>{this.getSessions("waitinglist")}</p>
        </div>
        <div className="clear"></div>
      </div>
    );
  }

  renderAvailable() {
    return (
      <div className="mt-40">
        <DataInfo
          label={lang.t("overview:member.availableclass")}
          value={
            this.state.ugroup
              ? lang.t("overview:member.unlimited")
              : this.state.available[0]
          }
        />
        <DataInfo
          label={lang.t("overview:member.available11")}
          value={
            this.state.u11
              ? lang.t("overview:member.unlimited")
              : this.state.available[1]
          }
        />
      </div>
    );
  }

  renderUnpaid() {
    if (this.state.unpaid.length > 0) {
    }
  }

  renderCredits() {
    if (this.state.packs.length > 0) {
      var list = this.state.packs;
      return (
        <div>
          <div className="listheader">
            <h3>{lang.t("overview:member.packs")}</h3>
            <div className="clear"></div>
          </div>
          {list.map((item) => (
            <div className="box list highlight mb-10" key={item.id}>
              <div className="col-10">
                <div className="icon secondary">
                  <div className={"inner " + this.getPackIcon(item)}></div>
                </div>
                <p className="lft" style={{ whiteSpace: "pre-wrap" }}>
                  <strong>
                    {item.data.expires === undefined
                      ? "General " +
                        (item.data.group ? "class" : "session") +
                        " credits"
                      : item.data.name}
                  </strong>
                  <br />
                  {this.getPackInfo(item)}
                </p>
                <div className="clear"></div>
              </div>
              <div className="clear"></div>
            </div>
          ))}
        </div>
      );
    }
  }

  renderMemberships() {
    if (this.state.memberships.length > 0) {
      var list = this.state.memberships;
      console.log({ list });
      return (
        <div>
          <div className="listheader">
            <h3>{lang.t("overview:member.memberships")}</h3>
            <div className="clear"></div>
          </div>
          {list.map((item) => (
            <div className="box list highlight mb-10" key={item.id}>
              <div className="col-10">
                <div className="icon secondary">
                  <div className="inner refresh"></div>
                </div>
                <p className="lft" style={{ whiteSpace: "pre-wrap" }}>
                  {console.log({ item })}
                  <strong>{item.data.name}</strong>
                  <br />
                  {this.getMembershipInfo(item)}
                  <br />
                  {this.getMembershipBilling(item)}
                </p>
                <div className="clear"></div>
              </div>
              <div className="clear"></div>
            </div>
          ))}
        </div>
      );
    }
  }

  renderFamilyName(item) {
    var label = "Member";
    for (var cl of global.clients) {
      if (cl.id === item) {
        label = cl.data.name;
      }
    }
    return label;
  }

  renderFamily() {
    if (global.userLinked.length > 0) {
      var list = global.userLinked;
      return (
        <div className="rgt mt-10">
          <select
            className="light lft"
            onChange={(event) => this.selectClient(event)}
            value={this.state.client}
          >
            <option value={global.spaceClient}>
              {lang.t("overview:member.yourself")}
            </option>
            {list.map((item) => (
              <option value={item}>{this.renderFamilyName(item)}</option>
            ))}
          </select>
        </div>
      );
    }
  }

  renderBase() {
    return (
      <div className={"theme-" + global.spaceTheme}>
        <div className="content form-sidebar">
          <div className="sv-30"></div>
          {this.renderStats()}
          {this.renderMemberships()}
          {this.renderCredits()}
          {this.renderUnpaid()}
          {this.renderAvailable()}
        </div>

        <div className="header">
          <div className="content">
            <Link to={"/" + global.uid + "/home"} className="back lft mr-10">
              <div className="circle"></div>
              <div className="arrow"></div>
            </Link>
            <h2 className="lft">{lang.t("overview:member.title")}</h2>
            {this.renderFamily()}
            <div className="clear"></div>
          </div>
        </div>
        <Navigation active="home" />
      </div>
    );
  }

  render() {
    return (
      <AuthUserContext.Consumer>
        {(authUser) => this.renderBase()}
      </AuthUserContext.Consumer>
    );
  }
}

const condition = (authUser) => !!authUser;
export default withTranslation([
  "header",
  "auth",
  "health",
  "common",
  "modal",
  "message",
])(withRouter(withAuthorizationMember(condition)(MembershipPage)));
